import InvitedTalks from "../components/InvitedTalks";

export default function InvitedTalksPage() {
  return (
    <section className="py-10">
      <InvitedTalks />
    </section>
  );
}
